import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AppContext } from "../Base";
import { readCookie } from "../consts/helpers";

export default function useAuthUser() {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const [isAuthView, setAuthView] = useState(false);

    const [isNewUser, setNewUser] = useState(false);
    const [userid, setUserid] = useState();

    // For setting AppContext
    const setUsername = useContext(AppContext).setUsername; 
    const setPoints = useContext(AppContext).setPoints; 
    const setCoins = useContext(AppContext).setCoins; 
    const setFootprint = useContext(AppContext).setFootprint;

    const checkAuth = () => {
        var email = readCookie('icare_se');
        var token = readCookie('icare_st');

        if (token === null || token === '') {
            navigate("/login");
        }

        if (email && token) {
            const url = process.env.REACT_APP_USERACCESS_LAMBDA + '?' + new URLSearchParams({ email: email, token: token });
            fetch(url, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
            }).then(
                function (response) {
                    return response.json();
                }
            ).then(
                function(data) {
                    setAuthView(data?.isAuth);

                    var fetchUserid = data?.userData?.userid;
                    setUserid(fetchUserid);
                    var fetchUsername = data?.userData?.username;
                    setUsername(fetchUsername);
                    var fetchPoints = data?.userData?.totalPoints || 0;
                    setPoints(fetchPoints);
                    var fetchCoins = data?.userData?.totalCoins || 0;
                    setCoins(fetchCoins);
                    var fetchFootprint = data?.userData?.carbonFootprint || 0;
                    setFootprint(fetchFootprint * 12);

                    setNewUser((fetchPoints === 0 && fetchFootprint === 0));

                    if (!data?.isAuth) navigate("/login",
                        {
                            state : {
                                message: pathname==='/login' ? "" : "Your session has ended, you have been logged out."
                            }
                        });
                }
            ).catch(
                function(error) {
                    console.log("PROROUTE:", error)
                }
            );
        } else setAuthView(false);
    }

    useEffect(() => {
        checkAuth();
    }, []);

    return {
        checkAuth: checkAuth,
        isAuthView: isAuthView,
        isNewUser : isNewUser,
        setNewUser : setNewUser,
        userid : userid,
    };
}